/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from '../common/react-redux-hooks';
import ACProjectContext from './ACContext/ACDefinitionContext';
import {
  getDefinitionTreeLoad,
  getDefinitionTargetLoad,
  clearDefinitionTarget,
} from '../../actions/definitionActions';
import ACDefinitionsFoldersList from './AutocodeDefinition/ACDefinitionsFoldersList';
import TargetDefinitions from './AutocodeDefinition/TargetDefinitions';
import AutocodeSelectionBox from './AutocodeSelectionBox/AutocodeSelectionBox';
import { useACSelectionBoxContext } from './ACContext/ACSelectionBoxContext';
import GenericButton from '../common/GenericButton';
import AutocodeSelectionAction from './AutocodeSelectionBox/AutocodeSelectionActions';
import { AC_ROOT_NODE_ID, AC_PERSONAL_FOLDER_SCOPE } from './AutocodeConstants';
import { useACEditContext } from './ACContext/ACEditContext';

const AutocodeDefinitionsTab = ({
  moduleStudy = {},
  uid,
  selectedWeightType,
  gridData,
  backToDef,
  moduleAction,
  menuName,
}) => {
  const [productNo, setProductNo] = useState(moduleStudy.pn);
  const [selectedFolder, setselectedFolder] = useState({});
  const [definitionTargetList, setdefinitionTargetlist] = useState([]);
  const [defDataPoints, setDefDataPoints] = useState([]);
  const [addButtonDisabled, setaddButtonDisabled] = useState(true);
  const [checkBlur, setCheckBlur] = useState(true);

  const { definitionList, activeAccountId, definitionTarget } = useSelector(
    state => ({
      definitionList: state.definition.definitionTree,
      definitionTarget: state.definition.definitionTarget,
      activeAccountId: state.account.activeAccountId,
    })
  );
  const dispatch = useDispatch();

  const {
    editFolderDetails,
    seteditFolderDetails,
    canAddNewFolders,
    canAddNewDefinitions,
    showDefEditBtn,
  } = useACEditContext();
  const acSelContext = useACSelectionBoxContext();
  const {
    removeAllNodes,
    insertDefinitionNodes,
    clearSelectionBox,
    cancelBulkJoinSetup,
    selectAllNodes,
    selectAllFunctions,
    selectAllOperators,
  } = AutocodeSelectionAction(acSelContext.state, acSelContext.dispatch);

  const clearSelections = e => {
    if (checkBlur && !e.currentTarget.contains(e.relatedTarget)) {
      cancelBulkJoinSetup();
      selectAllNodes(false);
      selectAllFunctions(false);
      selectAllOperators(false);
    }
  };

  const addDefDataPoints = data => {
    if (data.length && !defDataPoints.length) {
      setaddButtonDisabled(!addButtonDisabled);
    }
    const breadcrumbList = JSON.parse(
      window.localStorage.getItem('breadCrumb')
    );
    const breadcrumbs = breadcrumbList
      ? breadcrumbList.reverse().join(' > ')
      : undefined;
    const scope = selectedFolder.selectedFolder.scope;

    const records = data.map(values => ({
      ...values,
      breadcrumbs,
      scope,
      selectedFolder: selectedFolder.selectedFolder,
    }));
    records.map(values => delete values.checkState);

    setDefDataPoints(prevItems => [...prevItems, ...records]);
  };

  const removeDefDataPoints = data => {
    if (data.length > 1) {
      const expressionList = data.map(r => r.expressionId);
      setDefDataPoints(
        defDataPoints.filter(row => {
          return !expressionList.includes(row.expressionId);
        })
      );
      setaddButtonDisabled(!addButtonDisabled);
    } else {
      if (defDataPoints.length === 1) setaddButtonDisabled(!addButtonDisabled);
      setDefDataPoints(
        defDataPoints.filter(row => {
          return row.expressionId !== data[0].expressionId;
        })
      );
    }
  };

  const setEventTargetList = (checkState, definitionTargetList, row) => {
    if (checkState) {
      let localSelectedDefinitionData = [];
      let localAllDefinitionData = [];
      localSelectedDefinitionData = definitionTargetList.filter(
        i => i.checkState === true
      );
      if (localSelectedDefinitionData.length > 0) {
        const lastRow =
          localSelectedDefinitionData[localSelectedDefinitionData.length - 1];
        const startIndex = definitionTargetList.indexOf(lastRow);
        const endIndex = definitionTargetList.indexOf(row);
        let fromIndex = 0;
        let toIndex = 0;
        if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
          fromIndex = startIndex;
          toIndex = endIndex;
        } else {
          fromIndex = endIndex;
          toIndex = startIndex;
        }
        localAllDefinitionData = definitionTargetList.slice(
          fromIndex,
          toIndex + 1
        );
        setdefinitionTargetlist([
          ...definitionTargetList.slice(0, fromIndex),
          ...localAllDefinitionData.map(a =>
            a && a.display ? { ...a, checkState } : a
          ),
          ...definitionTargetList.slice(toIndex + 1),
        ]);
        localAllDefinitionData = localAllDefinitionData.map(a => ({
          ...a,
          checkState,
        }));
        const expressionList = defDataPoints.map(r => r.expressionId);
        const appendlist = localAllDefinitionData.filter(row => {
          return !expressionList.includes(row.expressionId);
        });
        const updatedAppendList = appendlist.filter(item => item.display);
        addDefDataPoints(updatedAppendList);
      } else {
        setdefinitionTargetlist(
          definitionTargetList.map(r =>
            r.expressionId === row.expressionId
              ? { ...r, checkState }
              : { ...r }
          )
        );
        addDefDataPoints([row]);
      }
    } else {
      setdefinitionTargetlist(
        definitionTargetList.map(r =>
          r.expressionId === row.expressionId ? { ...r, checkState } : { ...r }
        )
      );
      removeDefDataPoints([row]);
    }
  };

  const checkStateDefination = (checkState, row, all = false, event) => {
    if (all && !event) {
      setdefinitionTargetlist(
        definitionTargetList.map(r =>
          r && r.display ? { ...r, checkState } : r
        )
      );
      const updatedDefTargetList = [...definitionTargetList];
      const expressionList = defDataPoints.map(r => r.expressionId);
      if (checkState) {
        const appendlist = updatedDefTargetList.filter(row => {
          return !expressionList.includes(row.expressionId);
        });
        const updatedAppendList = appendlist.filter(item => item.display);
        addDefDataPoints(updatedAppendList);
      } else {
        removeDefDataPoints(updatedDefTargetList);
      }
    } else if (event && event.nativeEvent.shiftKey && !all) {
      setEventTargetList(checkState, definitionTargetList, row);
    } else {
      setdefinitionTargetlist(
        definitionTargetList.map(r =>
          r.expressionId === row.expressionId ? { ...r, checkState } : { ...r }
        )
      );

      checkState ? addDefDataPoints([row]) : removeDefDataPoints([row]);
    }
  };

  const addDefToSelectionBox = () => {
    if (defDataPoints.length) {
      insertDefinitionNodes(defDataPoints, AC_ROOT_NODE_ID);
      setaddButtonDisabled(!addButtonDisabled);
      setDefDataPoints([]);
      setdefinitionTargetlist(
        definitionTarget.data.map(r => ({
          ...r,
          checkState: false,
        }))
      );
    }
  };

  const removeDefSelectionsAfterDrop = () => {
    if (defDataPoints.length) {
      setaddButtonDisabled(!addButtonDisabled);
      setDefDataPoints([]);
      setdefinitionTargetlist(
        definitionTarget.data.map(r => ({
          ...r,
          checkState: false,
        }))
      );
    }
  };

  useEffect(() => {
    dispatch(clearDefinitionTarget());
    dispatch(
      getDefinitionTreeLoad(
        '',
        moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        activeAccountId,
        moduleStudy.pn
      )
    );
  }, []);

  useEffect(() => {
    if (productNo !== moduleStudy.pn) {
      dispatch(
        getDefinitionTreeLoad(
          '',
          moduleStudy.ss === 'SIMMONS' ? 1 : 2,
          activeAccountId,
          moduleStudy.pn
        )
      );
      setProductNo(moduleStudy.pn);
      setdefinitionTargetlist([]);
      setselectedFolder({});
      clearSelectionBox();
    }
  }, [moduleStudy]);

  useEffect(() => {
    const data =
      definitionTarget &&
      definitionTarget.data &&
      definitionTarget.data.map(r => ({ ...r, checkState: false }));
    setDefDataPoints([]);
    setaddButtonDisabled(true);
    setdefinitionTargetlist(data);
  }, [definitionTarget]);

  const onLeafNodeClicked = selectedFolder => {
    const breadCrumbList = [];
    breadCrumbList.push(selectedFolder.folderName);
    breadCrumbList.push('Definitions');
    window.localStorage.setItem('breadCrumb', JSON.stringify(breadCrumbList));
    setselectedFolder({ selectedFolder });

    dispatch(
      getDefinitionTargetLoad(
        activeAccountId,
        selectedFolder.definitionId,
        moduleStudy,
        selectedWeightType,
        true
      )
    );
  };

  useEffect(() => {
    if (backToDef && Object.keys(editFolderDetails).length) {
      acSelContext.state.setTabsIndex(1);
      onLeafNodeClicked(editFolderDetails[0].selectedFolder);
    }
  }, [backToDef]);

  const disableAdd = disableFlag => {
    setaddButtonDisabled(disableFlag);
  };

  return (
    <ACProjectContext.Provider
      value={{
        moduleStudy,
        definitionList,
        activeAccountId,
        uid,
        definitionTarget,
        defDataPoints,
        menuName,
      }}
    >
      <div
        className="row expanded"
        style={{ height: 'calc(100vh - 171px)' }}
        data-test="AutocodeDefinitionsTab"
      >
        <div className="columns small-3 medium-3 large-3 autocode-inner-left-col">
          <ACDefinitionsFoldersList
            definitionList={definitionList}
            onLeafNodeClicked={onLeafNodeClicked}
            selectedFolder={selectedFolder}
            setselectedFolder={setselectedFolder}
            canAddNewFolders={canAddNewFolders}
          />
        </div>
        <div className="columns small-3 medium-3 large-3 autocode-inner-middle-col">
          <TargetDefinitions
            definitionTargetList={definitionTargetList}
            checkStateDefination={checkStateDefination}
            selectedFolder={selectedFolder}
            addDefToSelectionBox={addDefToSelectionBox}
            canAddNewDefinitions={
              canAddNewDefinitions &&
              selectedFolder &&
              selectedFolder.selectedFolder &&
              (selectedFolder.selectedFolder.scope ===
                AC_PERSONAL_FOLDER_SCOPE.value1 ||
                selectedFolder.selectedFolder.scope ===
                  AC_PERSONAL_FOLDER_SCOPE.value2)
            }
            handleDragEnd={removeDefSelectionsAfterDrop}
            selectedWeightType={selectedWeightType}
          />
          <div style={{ borderTop: '1px solid #e0e0e0' }}>
            <div style={{ marginTop: '15px', marginLeft: '15px' }}>
              <GenericButton
                name="Add"
                btnStyle="addbutton"
                // eslint-disable-next-line react/jsx-boolean-value
                btnDisabled={addButtonDisabled}
                onBtnClick={addDefToSelectionBox}
              />
            </div>
          </div>
        </div>
        <div
          className="columns small-6 medium-6 large-6 autocode-inner-right-col ac-selection-box definitionTab"
          onBlur={e => {
            clearSelections(e);
          }}
        >
          <AutocodeSelectionBox
            definitionTab
            disableAdd={disableAdd}
            moduleStudy={moduleStudy}
            uid={uid}
            selectedWeightType={selectedWeightType}
            ExistingGridData={gridData}
            setCheckBlur={setCheckBlur}
            onLeafNodeClicked={onLeafNodeClicked}
            showDefEditBtn={showDefEditBtn}
            moduleAction={moduleAction}
            insertDefinitionNodes={insertDefinitionNodes}
            addDefToSelectionBox={addDefToSelectionBox}
          />
        </div>
      </div>
    </ACProjectContext.Provider>
  );
};

AutocodeDefinitionsTab.propTypes = {
  moduleStudy: PropTypes.shape({
    ss: PropTypes.string,
    pn: PropTypes.number,
  }),
  uid: PropTypes.number,
  selectedWeightType: PropTypes.shape({}),
  gridData: PropTypes.shape({
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  backToDef: PropTypes.bool,
  moduleAction: PropTypes.shape({}),
  menuName: PropTypes.string,
};

export default AutocodeDefinitionsTab;
